import { createSelector } from '@ngrx/store';
import { OutcomeState } from './outcomes.reducers';

export const outcomeFeatureKey = 'outcomes';

export const selectOutcomes = createSelector(
  (state: any) => state[outcomeFeatureKey],
  (outcomeState: OutcomeState) => outcomeState?.outcomes ?? [],
);

export const selectOutcomesTotal = createSelector(
  (state: any) => state[outcomeFeatureKey],
  (outcomeState: OutcomeState | undefined) => outcomeState?.total ?? 0,
);

export const selectOutcomesStudy = createSelector(
  (state: any) => state[outcomeFeatureKey],
  (outcomeState: OutcomeState) => outcomeState?.studyId ?? '',
);

export const selectActiveOutcomeDocument = createSelector(
  (state: any) => state[outcomeFeatureKey],
  (outcomeState: OutcomeState) => outcomeState?.activeDocument ?? undefined,
);
